import React from 'react';
export var useMultiBodiedExtensionActions = function useMultiBodiedExtensionActions(_ref) {
  var updateActiveChild = _ref.updateActiveChild,
    children = _ref.children,
    allowBodiedOverride = _ref.allowBodiedOverride,
    childrenContainer = _ref.childrenContainer;
  return React.useMemo(function () {
    return {
      changeActive: function changeActive(index) {
        if (!Number.isInteger(index)) {
          return false;
        }
        updateActiveChild(index);
        return true;
      },
      addChild: function addChild() {
        return false;
      },
      getChildrenCount: function getChildrenCount() {
        return children && Array.isArray(children) ? children.length : 0;
      },
      removeChild: function removeChild(_index) {
        return false;
      },
      updateParameters: function updateParameters(_parameters) {
        return false;
      },
      getChildren: function getChildren() {
        return [];
      },
      getChildrenContainer: function getChildrenContainer() {
        return allowBodiedOverride ? childrenContainer : null;
      }
    };
  }, [updateActiveChild, children, allowBodiedOverride, childrenContainer]);
};